import { User } from '../../utils/types/Users';
import { UpdateUserAction } from '../actions/UserActions';

const initialState: User = {
	firstName: '',
	lastName: '',
	role: null,
	hia: null,
	createdOn: null,
	uid: '',
};

export default function UserReducer(state = initialState, action: UpdateUserAction): User {
	switch (action.type) {
		case 'UPDATE USER':
			return Object.assign({}, action.payload);

		default:
			return state;
	}
}
